import React from 'react';
import { styled } from '@mui/material/styles';
import { Checkbox } from '@mui/material';
import { SlSelectedCheckbox, SlUnselectedCheckbox } from 'src/components/SvgIcons';
import { useStacklineTheme } from '@stackline/ui';
import colors from 'src/utils/colors';

export enum CheckboxDimensions {
  DEFAULT_WIDTH = '16px',
  DEFAULT_HEIGHT = '16px'
}

// Create a styled wrapper div for the checkbox
const CheckboxWrapper = styled('div')<{ disabled?: boolean }>(({ disabled }) => ({
  position: 'relative',
  display: 'inline-flex',
  ...(disabled && {
    '&::after': {
      content: '""',
      position: 'absolute',
      width: 'calc(100% - 4px)',
      height: 'calc(100% - 4px)',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      borderRadius: '4px',
      backgroundColor: colors.graysSecondary,
      zIndex: -1
    }
  })
}));

// Style the MUI checkbox to remove padding
const StyledCheckbox = styled(Checkbox)({
  padding: 0,
  '& .MuiSvgIcon-root': {
    fontSize: CheckboxDimensions.DEFAULT_WIDTH
  },
  position: 'relative',
  zIndex: 1
});

interface GrayBackgroundCheckboxProps {
  label: string;
  value: string | number;
  checked?: boolean;
  onClick?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
}

// Custom checkbox component with gray background when disabled
const GrayBackgroundCheckbox: React.FC<GrayBackgroundCheckboxProps> = ({
  label,
  value,
  checked,
  onClick,
  disabled
}) => {
  const theme = useStacklineTheme();

  return (
    <CheckboxWrapper disabled={disabled} title={label}>
      <StyledCheckbox
        disabled={disabled}
        value={value}
        onChange={onClick}
        checkedIcon={
          <SlSelectedCheckbox
            style={{
              width: CheckboxDimensions.DEFAULT_WIDTH,
              height: CheckboxDimensions.DEFAULT_HEIGHT
            }}
          />
        }
        icon={
          <SlUnselectedCheckbox
            style={{ 
              width: CheckboxDimensions.DEFAULT_WIDTH, 
              height: CheckboxDimensions.DEFAULT_HEIGHT
            }}
          />
        }
        checked={checked}
        disableRipple
        disableTouchRipple
        sx={{
          '&, &.Mui-checked': {
            color: theme.colors.primary
          }
        }}
      />
    </CheckboxWrapper>
  );
};

export default GrayBackgroundCheckbox;
